import { PageId } from 'constants/pages'

export const enum PageIdWoofzPpday65 {
  SUBSCRIPTIONS_PPDAY_65_N = PageId.SUBSCRIPTIONS_PPDAY_65_N,
  CHAT_UPSELL_PPDAY_65 = PageId.CHAT_UPSELL_PPDAY_65,
  UPSELL_PPDAY_65 = PageId.UPSELL_PPDAY_65,
  DOWNLOAD_PPDAY_65 = PageId.DOWNLOAD_PPDAY_65,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
